import { isEmpty } from "rxjs";
import { Pallet } from "src/app/domain/models/Pallet";

export class PalletUtils {

  static calculateBoxesPerPallet(pallet:Pallet): number
  {
    if(pallet.pallets && pallet.excelImportBoxesPerPallet)
    {
      return parseFloat(pallet.excelImportBoxesPerPallet) * parseFloat(pallet.excelImportBoxesPerPallet);
    }else if(pallet.excelImportBoxesPerPallet)
    {
      return parseFloat(pallet.excelImportBoxesPerPallet)
    }

    return 0;
  }
}
